export interface CmsBlock {
  id: string;
  type: string;
  sortOrder: number;
  props: Record<string, unknown>;
  blockDefinitionId?: string | null;
  loyaltyMembersOnly?: boolean;
  isLocked?: boolean;
  children?: CmsBlock[];
}

export interface CmsPageData {
  id: string;
  slug: string;
  title: string;
  metaTitle?: string | null;
  metaDescription?: string | null;
  ogImageUrl?: string | null;
  isLocked?: boolean;
  loyaltyMembersOnly?: boolean;
  spaceTheme?: Record<string, string>;
  spaceLayout?: Record<string, string>;
  blocks: CmsBlock[];
}

export interface CmsLayoutConfig {
  contentWidth?: 'narrow' | 'normal' | 'wide' | 'full';
  headerStyle?: 'sticky' | 'static' | 'transparent' | 'minimal';
  navPosition?: 'top' | 'sidebar-left';
  footerStyle?: 'none' | 'minimal' | 'full';
}

export const DEFAULT_LAYOUT: CmsLayoutConfig = {
  contentWidth: 'normal',
  headerStyle: 'sticky',
  navPosition: 'top',
  footerStyle: 'minimal',
};

export interface CmsNavItem {
  id: string;
  label: string;
  type: string;
  path: string;
  groupLabel: string | null;
  sortOrder: number;
  isExternal: boolean;
}

export interface CollectionEntry {
  id: string;
  title: string;
  slug?: string | null;
  dataJson: Record<string, unknown>;
  publishedAt: string | null;
}

export interface CollectionTemplateBlock {
  id: string;
  templateId: string;
  blockDefinitionId: string | null;
  parentBlockId: string | null;
  sortOrder: number;
  props: Record<string, unknown>;
  blockSlug?: string | null;
}

export interface CollectionTemplateData {
  id: string;
  name: string;
  blocks: CollectionTemplateBlock[];
}

export interface CollectionListResponse {
  entries: CollectionEntry[];
  total?: number;
  contentType?: {
    id: string;
    name: string;
    slug: string;
  };
  listingTemplate?: CollectionTemplateData | null;
}

export interface FieldDefinition {
  key: string;
  label: string;
  type: string;
  required?: boolean;
  options?: string[];
  contentTypeId?: string; // for type === 'relation'
  multiple?: boolean;     // for type === 'relation' — if true, value is UUID[]
}

export interface EntryDetailResponse {
  entry: CollectionEntry & {
    createdAt: string;
    updatedAt: string;
  };
  contentType: {
    id: string;
    name: string;
    slug: string;
    fieldsJson: FieldDefinition[];
  };
  detailTemplate?: CollectionTemplateData | null;
}
